import React from 'react'

import { AttachmentPreview } from 'components/AttachmentPreview'

import { useTenantAttachmentPreviewController } from './hooks/useTenantAttachmentPreviewController'

export const DeliveryWorkAttachmentPreviewPage: React.FC = () => {
  const { pageState, fileUrl, fileName, isPdf, isPreviewable } =
    useTenantAttachmentPreviewController()

  return (
    <AttachmentPreview
      pageState={pageState}
      fileUrl={fileUrl}
      fileName={fileName}
      isPdf={isPdf}
      isPreviewable={isPreviewable}
    />
  )
}
